
import { Component, inject, Input } from '@angular/core';
import { FormGroup, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-confirm-modal',
	imports: [ReactiveFormsModule],
	template: `
		<div class="modal-header">
		  <h4 class="modal-title">{{ title }}</h4>
		</div>
		<div class="modal-body">
		  <div class="wrap-text">		<!-- accapo automatico -->
		    @if (body) {
		      <p>
		        {{ body }}
		      </p>
		    }
		    @if (list) {
		      <ul>
		        @for (elem of list; track $index) {
		          <li>{{ elem }}</li>
		        }
		      </ul>
		    }
		    @if (!enableMotivationForm) {
		      <p>
		        Sei sicuro di voler procedere?
		      </p>
		    }
		  </div>
		  @if (enableMotivationForm) {
		    <form [formGroup]="motivationForm" (ngSubmit)="onSubmit()">
		      <textarea
		        id="motivation"
		        formControlName="motivation"
		        class="form-control"
		        rows="4"
		        [placeholder]="deleteItemKeyValue ? '' : 'Inserisci la motivazione'"
		      ></textarea>
		      @if (motivationForm.get('motivation')?.invalid && motivationForm.get('motivation')?.touched) {
		        <div class="text-danger">
		          @if (motivationForm.get('motivation')?.errors?.['required'] && !deleteItemKeyValue) {
		            <small i18n>La motivazione è obbligatoria.</small>
		          }
		          @if (motivationForm.get('motivation')?.errors?.['minlength']) {
		            <small i18n>La motivazione deve contenere almeno 7 caratteri.</small>
		          }
		        </div>
		      }
		    </form>
		  }
		</div>
		<div class="modal-footer">
		  <button type="button" class="btn btn-primary"
		    [disabled]="(deleteItemKeyValue && motivationForm.getRawValue().motivation !== deleteItemKeyValue) || (!deleteItemKeyValue && enableMotivationForm && motivationForm.invalid)"
		  (click)="activeModal.close(motivationForm.valid && motivationForm.getRawValue() || 'Confirm click')" i18n>Conferma</button>
		  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Undo click')" i18n>Annulla</button>
		</div>
		`
})
export class ConfirmModal {
	private readonly fb = inject(NonNullableFormBuilder);
	activeModal = inject(NgbActiveModal);

	motivationForm: FormGroup = this.fb.group({
		motivation: ['', [Validators.required, Validators.minLength(7)]]
	});

	@Input() title: string = '';
	@Input() body!: string;
	@Input() list!: string[];
	@Input() enableMotivationForm: boolean = false;
	@Input() deleteItemKeyValue!: string;

	onSubmit(): void {
		if (this.motivationForm.valid) {
			console.log(this.motivationForm.value);
		}
	}
}